import React, { useEffect, useState } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Hidden from "@material-ui/core/Hidden";
// @material-ui/icons
import Menu from "@material-ui/icons/Menu";
// core components
import AdminNavbarLinks from "./AdminNavbarLinks.js";
import RTLNavbarLinks from "./RTLNavbarLinks.js";
// import Button from "../CustomButtons/Button";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import { NavLink } from "react-router-dom";
import constants from "../../constants/navbarOptions";
import { useUser } from "../../context/userContext";
//hooks
import { useRouteName } from "hooks";
import styles from "assets/jss/material-dashboard-react/components/headerStyle.js";
import stylesBtn from "assets/jss/material-dashboard-react/components/buttonStyle";
import { Button } from "@material-ui/core";
import ButtonSystemControl from "components/CustomButtons/ButtonSystemControl.jsx";
const useStyles = makeStyles(styles);
const useStylesBtn = makeStyles(stylesBtn);

export default function Header(props) {
  const routeName = useRouteName();
  const [isDisabledBtn, setDisableBtn] = useState(false);
  useEffect(() => {
    if (routeName === "Draw" || routeName === "Response automaton") {
      setDisableBtn(false);
    } else {
      setDisableBtn(true);
    }
  }, [routeName]);
  const classes = useStyles();
  const classesBtn = useStylesBtn();

  const { color } = props;
  const appBarClasses = classNames({
    [" " + classes[color]]: color,
  });
  const { language, isAdmin, setIsAdmin, isAuth } = useUser();

  useEffect(() => {
    setIsAdmin(isAdmin);
  }, [isAdmin]);

  const returnBackgroundColorByRoute = (button) => {
    if (button === "draw") {
      if (routeName === "Draw") {
        return "blue";
      } else {
        return "";
      }
    } else if (button === "response") {
      if (routeName === "Response automaton") {
        return "blue";
      } else {
        return "";
      }
    }
  };

  return (
    <AppBar className={classes.appBar + appBarClasses}>
      <Toolbar className={classes.container}>
        <div className={classes.flex}>
          {/* Here we create navbar brand, based on route name  */}
          <Breadcrumbs aria-label="breadcrumb">
            {/* <Button
              disabled={teste}
              style={{
                backgroundColor: returnBackgroundColorByRoute("draw"),
              }}
            > */}
            {isAuth && (
              <div>
                <Button
                  disabled={isDisabledBtn}
                  className={classesBtn.button}
                  style={{
                    backgroundColor: returnBackgroundColorByRoute("draw"),
                  }}
                >
                  <NavLink
                    to="/user/automaton"
                    key={0}
                    className={classes.link}
                  >
                    {constants.buttons.optionsDraw.draw[language]}
                  </NavLink>
                </Button>
                <Button
                  disabled={isDisabledBtn}
                  className={classesBtn.button}
                  style={{
                    backgroundColor: returnBackgroundColorByRoute("response"),
                  }}
                >
                  <NavLink
                    to="/user/responseAutomaton"
                    key={1}
                    className={classes.link}
                  >
                    {constants.buttons.optionsDraw.response[language]}
                  </NavLink>
                </Button>
              </div>
            )}
          </Breadcrumbs>
        </div>
        {isAdmin && <ButtonSystemControl />}
        <Hidden smDown implementation="css">
          {props.rtlActive ? (
            <div>
              <RTLNavbarLinks />
            </div>
          ) : (
            <div>
              <AdminNavbarLinks
                router={routeName}
                rtlActive={props.rtlActive}
              />
            </div>
          )}
        </Hidden>
        <Hidden mdUp implementation="css">
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={props.handleDrawerToggle}
          >
            <Menu />
          </IconButton>
        </Hidden>
        {/* </div> */}
      </Toolbar>
    </AppBar>
  );
}

Header.propTypes = {
  color: PropTypes.oneOf(["primary", "info", "success", "warning", "danger"]),
  rtlActive: PropTypes.bool,
  handleDrawerToggle: PropTypes.func,
  routes: PropTypes.arrayOf(PropTypes.object),
};
